(() => {
 if (window.ugFavoritesReady) return;
 window.ugFavoritesReady = true;
 const key='ug-favorites-v1';
 const config=document.getElementById('UGFavoritesConfig');
 const cfg=config ? JSON.parse(config.textContent) : {};
 const heart='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
 let favorites=[];
 const canonical=url=>{const u=new URL(url,location.origin);if(u.origin!==location.origin || !u.pathname.includes('/products/'))return null;return u.pathname;};
 const read=()=>{try{const data=JSON.parse(localStorage.getItem(key)||'[]');favorites=Array.isArray(data)?data.filter(x=>x&&typeof x.url==='string'&&canonical(x.url)&&typeof x.title==='string').slice(0,200):[];}catch{favorites=[];}};
 const saved=url=>favorites.some(x=>x.url===url);
 const favoriteItems=new WeakMap();
 const status=document.createElement('span');status.className='visually-hidden';status.setAttribute('role','status');document.body.append(status);
 const dialog=document.createElement('dialog');dialog.className='ug-favorites-dialog';dialog.setAttribute('aria-labelledby','UGFavoritesTitle');
 const heading=document.createElement('h2');heading.id='UGFavoritesTitle';heading.textContent=cfg.heading||'Omiljeni modeli';
 const close=document.createElement('button');close.type='button';close.className='ug-favorites-close';close.textContent='×';close.setAttribute('aria-label',cfg.close||'Zatvori');
 const list=document.createElement('div');list.className='ug-favorites-list';
 const note=document.createElement('p');note.className='ug-favorites-note';note.textContent=cfg.note||'Lista se čuva u ovom pregledaču. Registracija nije potrebna.';
 dialog.append(heading,close,note,list);document.body.append(dialog);
 let opener;
 close.addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
 dialog.addEventListener('close',()=>opener?.focus());

 const priceRequests=new Set();
 let priceQueueRunning=false;
 async function hydratePrices(){
  if(priceQueueRunning)return;
  const missing=favorites.filter(item=>!priceRequests.has(item.url));
  if(!missing.length)return;
  priceQueueRunning=true;
  const worker=async()=>{
   while(missing.length){
    const item=missing.shift();priceRequests.add(item.url);
    try{
     const response=await fetch(item.url+'.js');
     if(!response.ok)continue;
     const product=await response.json();
     const entry=favorites.find(x=>x.url===item.url);
     if(entry&&Number.isFinite(product.price)){
      entry.price=new Intl.NumberFormat('sr-RS',{maximumFractionDigits:0}).format(product.price/100)+' RSD';
      if(product.price_varies)entry.price='Od '+entry.price;
      if(product.featured_image)entry.image=product.featured_image;
      try{localStorage.setItem(key,JSON.stringify(favorites));}catch{}
     }
    }catch{}
   }
  };
  try{await Promise.all(Array.from({length:Math.min(4,missing.length)},worker));}
  finally{priceQueueRunning=false;if(dialog.open)render();}
 }

 const render=()=>{
  hydratePrices();
  list.replaceChildren();
  if(!favorites.length){const p=document.createElement('p');p.textContent=cfg.empty||'Sačuvaj modele koji ti se sviđaju klikom na srce.';list.append(p);return;}
  favorites.forEach(item=>{
   const row=document.createElement('div');row.className='ug-favorite-row';
   const link=document.createElement('a');link.href=item.url;
   if(item.image){try{const url=new URL(item.image,location.origin);if(url.protocol==='https:'){if(url.hostname===location.hostname||url.hostname==='cdn.shopify.com'){url.searchParams.set('width','480');url.searchParams.delete('height');url.searchParams.delete('crop');}const frame=document.createElement('span');frame.className='ug-favorite-thumb';const img=document.createElement('img');img.src=url.href;img.alt=item.title;img.width=120;img.height=100;img.loading='eager';img.decoding='async';frame.append(img);link.append(frame);}}catch{}}
   const text=document.createElement('span');text.className='ug-favorite-copy';const title=document.createElement('strong');title.textContent=item.title;const price=document.createElement('small');price.textContent=item.price||'Pogledaj cenu';text.append(title,price);link.append(text);
   const remove=document.createElement('button');remove.type='button';remove.textContent='×';remove.setAttribute('aria-label',(cfg.remove||'Ukloni iz omiljenih')+': '+item.title);
   remove.addEventListener('click',()=>toggle(item));
   row.append(link,remove);list.append(row);
  });
 };
 const sync=()=>{
  document.querySelectorAll('[data-ug-favorite]').forEach(button=>{
   const active=saved(button.dataset.ugFavorite);
   button.setAttribute('aria-pressed',String(active));button.classList.toggle('is-saved',active);
   button.setAttribute('aria-label',active?(cfg.remove||'Ukloni iz omiljenih'):(cfg.add||'Dodaj u omiljene'));
  });
  document.querySelectorAll('[data-ug-favorites-count]').forEach(n=>{if(n.textContent!==String(favorites.length)) n.textContent=String(favorites.length);n.hidden=!favorites.length;});
  document.querySelectorAll('[data-ug-open-favorites]').forEach(button=>button.classList.toggle('has-favorites',favorites.length>0));
  if(dialog.open)render();
 };
 const toggle=item=>{
  const active=saved(item.url);
  favorites=active?favorites.filter(x=>x.url!==item.url):[item,...favorites].slice(0,200);
  let persisted=true;try{localStorage.setItem(key,JSON.stringify(favorites));}catch{persisted=false;}
  status.textContent=persisted?(active?(cfg.removed||'Uklonjeno iz omiljenih.'):(cfg.saved||'Sačuvano u omiljenim.')):(cfg.session||'Sačuvano za ovu posetu. Pregledač ne dozvoljava trajno čuvanje.');
  sync();
 };
 const addButton=(host,item,product=false)=>{
  const url=canonical(item.url);if(!url)return;
  item.url=url;
  const button=document.createElement('button');button.type='button';button.className=product?'ug-favorite-product':'ug-favorite-heart';button.dataset.ugFavorite=url;button.innerHTML=heart;
  if(product){const label=document.createElement('span');label.textContent=cfg.add||'Dodaj u omiljene';button.append(label);}
  favoriteItems.set(button,item);
  host.append(button);
 };
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-ug-favorite]');
  if(!button)return;
  const item=favoriteItems.get(button);
  if(!item)return;
  event.preventDefault();
  event.stopImmediatePropagation();
  toggle(item);
 },true);
 let scheduled=false;
 const scan=()=>{
  scheduled=false;
  document.querySelectorAll('.ugx-card[href],.ug-card,#product-grid .card-wrapper,.product-grid .card-wrapper').forEach(card=>{
   if(card.dataset.ugWishReady)return;card.dataset.ugWishReady='true';
   const link=card.matches('a[href]')?card:card.querySelector('a[href*="/products/"]');
   if(!link)return;
   const img=card.querySelector('img');
   const title=card.querySelector('.ugx-name,.ug-name,.card__heading')?.textContent.trim()||img?.alt||link.textContent.trim();
   const price=(card.querySelector('.ugx-now,.ug-now,.ug-price,.price--on-sale .price-item--sale')||card.querySelector('.price__regular .price-item--regular'))?.textContent.trim()||'';
   let host=card.matches('.card-wrapper') ? card : card.closest('.ug-item');
   if(!host){host=document.createElement('div');host.className='ug-wish-wrap';card.before(host);host.append(card);}
   host.classList.add('ug-wish-host');
   addButton(host,{url:link.href,title,image:img?.currentSrc||img?.src||'',price});
  });
  document.querySelectorAll('product-info').forEach(scope=>{
   if(scope.dataset.ugWishReady||!cfg.product)return;scope.dataset.ugWishReady='true';
   const title=scope.querySelector('.product__title');if(!title)return;
   let host=scope.querySelector('[data-ug-product-favorite]');
   if(!host){host=document.createElement('div');host.className='ug-favorite-product-wrap';title.after(host);}
   addButton(host,cfg.product,true);
  });
  const icons=document.querySelector('.header__icons');
  if(icons&&!icons.querySelector('[data-ug-open-favorites]')){
   const button=document.createElement('button');button.type='button';button.className='header__icon ug-favorites-open';button.dataset.ugOpenFavorites='true';button.setAttribute('aria-label',cfg.heading||'Omiljeni modeli');button.innerHTML=heart;
   const count=document.createElement('span');count.dataset.ugFavoritesCount='true';count.className='ug-favorites-count';button.append(count);
   button.addEventListener('click',()=>{opener=button;render();dialog.showModal();});
   const cart=icons.querySelector('#cart-icon-bubble');if(cart)cart.before(button);else icons.append(button);
  }
  sync();
 };
 const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(scan);}};
 read();scan();
 new MutationObserver(records=>{if(records.some(r=>r.type==='childList'&&!dialog.contains(r.target)&&r.target!==status))schedule();}).observe(document.body,{childList:true,subtree:true});
 window.addEventListener('storage',event=>{if(event.key===key){read();sync();}});
})();

